import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-bigger',
  templateUrl: './logo-bigger.component.html',
  styleUrls: ['./logo-bigger.component.scss']
})
export class LogoBiggerComponent implements OnInit {

  @Input() small: boolean;
  @Input() showAlt: boolean;

  constructor() { }

  ngOnInit() {
  }

}
